
// wrapper for Websql & cordova sqlite plugin

export default class Sql{
    
    constructor(options){

      this.name="webSql";
      this.options=options;
      this.db;
      this.db_manager; // the plugin or function on window
      this.data=[];

    }

    async openDatabase(){
     
      this.db_manager=window;
      await this._open_websql().then(
        db=>{
          this.name="webSql";
          this.db=db;
        },
        ()=>{
          console.log("could not open db_websql")
          //could not open websql
        }
      )
      
      /*
      if(!this.db){
        this.db_manager=window.sqlitePlugin;
        await this._open_sqlite().then(
          db=>{
            this.name="sqlite plugin";
            this.db=db;
          },
          ()=>{
            //could not open websql
            console.log("could not open db_sqlite")
          }
        )
      }
      */

      if(this.db){
        return Promise.resolve();
      }else{
        return Promise.reject("COULD NOT OPEN SQL DATABASE");
      }
      

    }


    /* create table on web sql if non exist*/
    createTable(){
    
      return new Promise((resolve,reject)=>{
        this.db.transaction((tx) => {
          tx.executeSql('CREATE TABLE IF NOT EXISTS DATA (key unique, val blob)',[],
            () => {
              resolve();
              //this.parseDatabase(resolve,reject);
            },
            () => {
              reject("COULD NOT_CREATE_SQL_TABLE WebSql_createTable");
              //reject("error: could not create table");
            });   
        });
      })
      
    }


    _open_websql(){
     
      return new Promise((resolve,reject)=>{
        try{
          
          if(this.db_manager.openDatabase){
           
            var db=this.db_manager.openDatabase(this.options.name, this.options.version, this.options.displayName, this.options.maxSize);
            resolve(db)

          }else{
            reject();
          }
          
        }catch(error){
          reject();
        }
      })
      
      
    }

    // open with cordova sqlite plugin, so this is deprecated
    /*
    _open_sqlite(){
      
      return new Promise((resolve,reject)=>{
        try{
          if(this.db_manager.openDatabase && window.cordova.platformId!="browser"){
          
            var db=this.db_manager.openDatabase(this.options,
              ()=>{resolve(db)},
              ()=>{reject()})
          }else{
            reject();
          }
          
        }catch(error){
          reject();
        }
      })
      
    }
*/
    


    parseDatabase(){
      
      return new Promise((resolve,reject)=>{

          this.db.transaction( (tx) => {
            tx.executeSql('SELECT * FROM DATA', [],
            
              (tx, results) => { // success
              var len = results.rows.length, i;
              
              for (i = 0; i < len; i++){
                  var key=results.rows.item(i).key;
                  var val=results.rows.item(i).val;
                  this.data[key]=val;
                  //console.log("...PARSING: key=",key," val=",val)
              }
              resolve(this.data);
            }, 
            () => { 
              reject("error: could not parse database sql");
            });
        });


      }) // promise

      
    }


    setItem(key,val){
        
      // insert into local data object
      this.data[key]=val;
    
      // write to sql database
      this.db.transaction((tx) => {
    
        // delete record
        tx.executeSql('DELETE FROM DATA WHERE key = ?', [key],
        () => { // success
          // insert fresh record
    
          tx.executeSql('INSERT INTO DATA (key, val) VALUES (?, ?)',[key,val],
            () => {
               //this.setValueSuccess(key,val);

            },
            () => {
              //this.setValueError(key,val,e);
            });
    
        },
        ()=>{ // error
           alert("key not deleted")
        });
    
      });
    
      
    }
    
    // get item from storage by key
    getItem(key){

      return this.data[key];
      
    }
    
    clear(){
      this.db.transaction(function (tx) {
        tx.executeSql('DROP TABLE DATA');
      });
      
      // re do this stuff
      this.openDatabase();

    }
    
   // print out the stored information 
   print(){
      console.log("********** LOCAL STORAGE *************");
      
      for(var key in this.data){
        
        console.log("key= ",key);
        console.log("var= ",this.data[key]);
        console.log("-----------")
      }
      console.log("********** /LOCAL STORAGE *************")
    }





    
  }
